// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigatorСode-message-bar {
  display: grid;
  background: #ffffff;
  border: 0.1vw solid #1a6a7c;
  border-radius: 1.5vw;
  text-align: center;
  place-items: center;
  height: 2.2vw;
  padding: 0.1vw;
  color: #1a6a7c;
  font-size: 1.5vw;
}

.navigatorСode-top-bar {
  display: grid;
  align-items: center;

  grid-template-columns: min-content auto 2.2vw;
  gap: 0.4vw;
}

a.navigatorСode-logo {
  height: 2.2vw;
  margin-left: 4vw;
  margin-right: 4vw;
}

img.navigatorСode-logo {
  position: relative;
  bottom: 2.4vw;
  height: 6vw;
}
.navigatorСode-icon {
  cursor: pointer;
  height: 100%;
  width: 2.2vw;
}
#navigatorСode-help-icon:active {
  filter: brightness(0.8);
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/Navigator%D0%A1odeTopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".navigatorСode-message-bar {\n  display: grid;\n  background: #ffffff;\n  border: 0.1vw solid #1a6a7c;\n  border-radius: 1.5vw;\n  text-align: center;\n  place-items: center;\n  height: 2.2vw;\n  padding: 0.1vw;\n  color: #1a6a7c;\n  font-size: 1.5vw;\n}\n\n.navigatorСode-top-bar {\n  display: grid;\n  align-items: center;\n\n  grid-template-columns: min-content auto 2.2vw;\n  gap: 0.4vw;\n}\n\na.navigatorСode-logo {\n  height: 2.2vw;\n  margin-left: 4vw;\n  margin-right: 4vw;\n}\n\nimg.navigatorСode-logo {\n  position: relative;\n  bottom: 2.4vw;\n  height: 6vw;\n}\n.navigatorСode-icon {\n  cursor: pointer;\n  height: 100%;\n  width: 2.2vw;\n}\n#navigatorСode-help-icon:active {\n  filter: brightness(0.8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
